import { MODEL_KEY } from '../../../model/constants'

import getLocalId from '../get-local-id'
import { getValueReduxUtil } from '../get-value'

export function getIdReduxUtil (instance) {
  if (!instance) {
    return
  }
  return (
    getValueReduxUtil(instance, MODEL_KEY.ID) || getLocalId(instance)
  )
}
